import React, { useDebugValue, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetFlowComponentList } from "../../../Redux/Reducers/Manager/FlowComponent";
import { useNavigate, useParams } from "react-router-dom";
import EmployeeNotes from "../EmployeeNotes";
import MinutesOfMeeting from "../MinutesOfMeeting";
import ApplicationInfoSelected from "../ApplicationInfoSelected";
import EvaluatorsNamesThatWillTransferRequestForTable from "../EvaluatorsNamesThatWillTransferRequestForTable";
import ScientificCommitteeNamesThatWillTransferRequestFor from "../ScientificCommitteeNamesThatWillTransferRequestFor";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import { WorkFlowStep } from "../../../Redux/Reducers/Manager/WorkFlowSteps";
import { GetScientificCommitteeListByFieldIdSubjectId } from "../../../Redux/Reducers/Manager/ScientificCommittee";
import { use } from "react";
import { GetEvaluatorInfoByRoundFieldSubject } from "../../../Redux/Reducers/Manager/EvaluatorInfo";
import Swal from "sweetalert2";
import { GetActionById } from "../../../Redux/Reducers/Manager/FlowActionEmployee";
import PopupAHSF from "../../../Components/PopupAHSF";
import ValidationView from "../../../Components/ValidationView";
import { CompletionOfArbitration } from "../../../Redux/Reducers/Manager/SubTask";

const TaskTakeAction = (props) => {
  const lang = useSelector((state) => state.languageReducer.Language);
  const resultJson = useSelector((state) => state.FetchDataJson.JsonData);

  const [
    ValidateApplicantInformationList,
    setValidateApplicantInformationList,
  ] = useState([]);
  const [
    PopupComponentValidationViewStatus,
    setPopupComponentValidationViewStatus,
  ] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { actionId, flowId, roundId, fieldId, subjectId } = useParams();
  const arrayDataCheckBoksevalList = useSelector(
    (state) => state.arrayDataCheckBoks?.arrayDataCheckBoks["evalList"]
  );
  const FlowComponentList = useSelector((state) =>
    state.FlowComponent.FlowComponent?.map((item) => item.componentId)
  );
  const ActionById = useSelector(
    (state) => state.FlowActionEmployee.ActionById
  );
  const ScientificCommitteeList = useSelector(
    (state) =>
      state.ScientificCommittee.GetScientificCommitteeListByFieldIdSubjectId
  );
  const EvaluatorInfoByRoundFieldSubjectList = useSelector(
    (state) => state.EvaluatorInfo.GetEvaluatorInfoByRoundFieldSubject
  );
  const arrayDataCheckBoks = useSelector(
    (state) => state.arrayDataCheckBoks.arrayDataCheckBoks
  );
  const [note, setNote] = useState("");
  const [file, setFile] = useState("");
  // const alls
  useEffect(() => {
    dispatch(
      GetFlowComponentList({
        flowId: flowId,
        actionId: actionId,
      })
    );

    dispatch(GetActionById({ actionId: actionId }));
  }, []);
  useEffect(() => {
    if (actionId == "555cc225-4aaa-4a94-b907-85ad73dd0c45") {
      dispatch(
        GetScientificCommitteeListByFieldIdSubjectId({
          fieldId: fieldId,
          subjectId: subjectId,
          roundYearId: roundId,
        })
      );
    }

    if (actionId == "c964fe68-0dfd-4b19-b6d3-a856fe561822") {
      dispatch(
        GetEvaluatorInfoByRoundFieldSubject({
          fieldId: fieldId,
          subjectId: subjectId,
          roundId: roundId,
        })
      );
    }
  }, [fieldId, subjectId, actionId, roundId]);
  // console.log();
  console.log(
    ScientificCommitteeList,
    "ssssssssssssdsdssssssssssssssssssssdw",
    ScientificCommitteeList?.map((user) => user.userId)
  );
  console.log(arrayDataCheckBoksevalList, "sssssssssssssssssssdw");

  const TakeActionWorkFlow = async () => {
    const formData = new FormData();
    let body;
    formData.append("ActionId", actionId);
    formData.append("FlowId", flowId);
    formData.append("ApplicationInformationId", file);
    formData.append("EmployeeFeedback", note);

    arrayDataCheckBoks?.tasksList?.map((task) =>
      formData.append("tasksIdsList", task.taskId)
    );
    if (
      actionId == "555cc225-4aaa-4a94-b907-85ad73dd0c45" ||
      actionId == "c964fe68-0dfd-4b19-b6d3-a856fe561822"
    ) {
      if (actionId == "555cc225-4aaa-4a94-b907-85ad73dd0c45")
        ScientificCommitteeList.forEach((elem) => {
          formData.append("UsersList", elem.userId);
        });

      if (actionId == "c964fe68-0dfd-4b19-b6d3-a856fe561822")
        arrayDataCheckBoksevalList?.forEach((elem) => {
          console.log(elem, "saaaaa");

          formData.append("UsersList", elem.userSSOGuid);
        });
    }
    // else{
    //    formData.append("UsersList", "");
    // }
    // formData.append(
    //   "UsersList",
    //   actionId == "555cc225-4aaa-4a94-b907-85ad73dd0c45"
    //     ? ScientificCommitteeList?.map((user) => user.userId)
    //     : actionId == "c964fe68-0dfd-4b19-b6d3-a856fe561822"
    //     ? EvaluatorInfoByRoundFieldSubjectList.map(
    //         (EvaluatorInfo) => EvaluatorInfo.userSSOGuid
    //       )
    //     : []
    // );
    formData.append("AttachedMinutesMeeting", file);

    const missingFields = [];
    if (
      FlowComponentList?.includes("b5fc6f8f-1040-42a2-b0ac-ee61bc82852b") &&
      (note == null || note == "")
    ) {
      missingFields.push("ملاحظات الموظف");
    }
    if (
      FlowComponentList?.includes("f5aa9d79-8c5b-4014-96dc-2f0641b3fef7") &&
      (file == null || file == "")
    ) {
      missingFields.push(" مرفق محضر الإجتماع ");
    }
    if (
      !arrayDataCheckBoks.tasksList ||
      arrayDataCheckBoks.tasksList.length === 0
    ) {
      missingFields.push("يجب اختيار طلب واحد على الاقل");
    }
    if (
      actionId == "555cc225-4aaa-4a94-b907-85ad73dd0c45" &&
      (ScientificCommitteeList == null || ScientificCommitteeList.length == 0)
    ) {
      missingFields.push("يجب اضافة عضو هيئة علمية واحد على الاقل");
    }
    //////////
    if (
      actionId == "c964fe68-0dfd-4b19-b6d3-a856fe561822" &&
      (arrayDataCheckBoksevalList == null ||
        arrayDataCheckBoksevalList.length == 0)
    ) {
      missingFields.push("يجب اضافة محكم واحد على الاقل");
    }
    console.log(arrayDataCheckBoks, "arrayDataCheckBoks");

    if (missingFields.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "الرجاء تعبئة الحقول التالية",
        html: `
        <div style="text-align: right; direction: rtl; font-size: 16px;">
          <ul style="list-style-type: none; padding: 0;">
            ${missingFields
              .map(
                (field) =>
                  `<li style="margin-bottom: 8px;">🔸 <strong>${field}</strong></li>`
              )
              .join("")}
          </ul>
        </div>
      `,
        confirmButtonText: "حسناً",
        customClass: {
          popup: "swal2-border-radius",
        },
      });
      return;
    }

    Swal.fire({
      title: "  هل انت متأكد من اخذ الاجراء ؟",

      icon: "question",
      // iconHtml: "؟",
      confirmButtonText: "تأكيد",
      cancelButtonText: "إلغاء",
      showCancelButton: true,
      showCloseButton: true,
    }).then(async (res) => {
      if (res.isConfirmed == true) {
        var resultWorkFlow = await dispatch(WorkFlowStep(formData));

        if (resultWorkFlow.payload?.success) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "تم حفظ المعلومات بنجاح",
            showConfirmButton: false,
            timer: 1500,
            // width: "500px",
          });
          setValidateApplicantInformationList([]);
          navigate("/ResearchersAward/manager/ActionOnApplications/");
        } else {
          if (resultWorkFlow?.payload?.result?.length > 0) {
            setPopupComponentValidationViewStatus(true);
            setValidateApplicantInformationList(
              resultWorkFlow?.payload?.result
            );
          }
        }
      }
    });

    //  console.log(resultWorkFlow,"sssssssssdwdwdwd");

    // if (resultWorkFlow.payload?.success) {
    //   navigate("/researcher/manager/ActionOnApplications/");
    // }
  };
  console.log(ValidateApplicantInformationList, "sssssssdddddddssssssdwdwd");
  const closePopupComponentValidationViewStatus = () => {
    // Function to toggle the visibility of the validation popup
    if (PopupComponentValidationViewStatus) {
      setPopupComponentValidationViewStatus(false); // Closing the popup
    } else {
      setPopupComponentValidationViewStatus(true); // Opening the popup
    }
  };

  const CompletionOfArbitration_ = async () => {
    Swal.fire({
      title: "  هل انت متأكد من اخذ الاجراء ؟",

      icon: "question",
      // iconHtml: "؟",
      confirmButtonText: "تأكيد",
      cancelButtonText: "إلغاء",
      showCancelButton: true,
      showCloseButton: true,
    }).then(async (res) => {
      if (res.isConfirmed == true) {
        var taskId = arrayDataCheckBoks?.tasksList.map((task) => task.taskId);
        if (taskId.length > 0) {
          var result = await dispatch(
            CompletionOfArbitration({ subTaskIdList: taskId })
          );

          if (result.payload?.length > 0) {
            setPopupComponentValidationViewStatus(true);
            setValidateApplicantInformationList(result?.payload);
          } else {
            // setPopupComponentValidationViewStatus(false);
            // setValidateApplicantInformationList([]);
            // navigate("/researcher/manager/ActionOnApplications/");




      
          Swal.fire({
            position: "center",
            icon: "success",
            title: "تم حفظ المعلومات بنجاح",
            showConfirmButton: false,
            timer: 1500,
            // width: "500px",
          });
           setPopupComponentValidationViewStatus(false);
          setValidateApplicantInformationList([]);
          navigate("/ResearchersAward/manager/ActionOnApplications/");
        





          }
        }


      }
    });

    // var taskId = arrayDataCheckBoks?.tasksList.map((task) => task.taskId);
  };

  return (
    <>
      {FlowComponentList?.includes("e12593ed-1937-48bd-bdec-03509c154c5d") ? (
        <ApplicationInfoSelected />
      ) : (
        <></>
      )}
      {FlowComponentList?.includes("1bc0a4c5-a224-44e2-8e15-7c70981b19c2") ? (
        <ScientificCommitteeNamesThatWillTransferRequestFor
          roundId={roundId}
          fieldId={fieldId}
          subjectId={subjectId}
        />
      ) : (
        <></>
      )}
      {FlowComponentList?.includes("e8465bb6-ee06-48da-969f-425c58389a81") ? (
        <EvaluatorsNamesThatWillTransferRequestForTable
          roundId={roundId}
          fieldId={fieldId}
          subjectId={subjectId}
        />
      ) : (
        <></>
      )}
      {FlowComponentList?.includes("b5fc6f8f-1040-42a2-b0ac-ee61bc82852b") ? (
        <EmployeeNotes setNote={setNote} />
      ) : (
        <></>
      )}
      {FlowComponentList?.includes("f5aa9d79-8c5b-4014-96dc-2f0641b3fef7") ? (
        <MinutesOfMeeting setFile={setFile} />
      ) : (
        <></>
      )}

      <div className="containerButtonMAin">
        {/* <ButtonAHSF
          type={"submitter"}
          fieldsName="TakeAction"
          lang={"ar"}
          text={ActionById?.actionName}
          onClick={() => {
            TakeActionWorkFlow();
          }}
          disabled={false}
          title={ActionById?.actionName}
          show={true}
        /> */}
        <button
          className="custom-button"
          onClick={() => {
            TakeActionWorkFlow();
          }}
        >
          {ActionById?.actionName}
        </button>

        <>
          {actionId == "c964fe68-0dfd-4b19-b6d3-a856fe561822" ? (
            <>
              <button
                className="custom-button"
                onClick={() => {
                  CompletionOfArbitration_();
                }}
              >
                {resultJson?.CompletionOfArbitration?.nameAR}
              </button>
            </>
          ) : (
            <></>
          )}
        </>
      </div>

      <PopupAHSF
        title={
          lang == "ar"
            ? "يرجى تعبئة الحقول المطلوبة"
            : "Please fill all the required fields"
        }
        componentBody={
          <ValidationView ValidationList={ValidateApplicantInformationList} />
        }
        maxWidth="700px"
        maxHeight="800px"
        isPopupOpenStatus={
          PopupComponentValidationViewStatus &&
          ValidateApplicantInformationList.length > 0
        } // Popup open status
        isPopupOpenFunction={closePopupComponentValidationViewStatus} // Function to close the popup
      />
    </>
  );
};

export default TaskTakeAction;
